<!--Copy right - © 2024 tecera gmbh-->
<script>
    export let alarm_triggered;
    export let show_old_alarms;
    export let type;
    export let alarm_list;
    import {
        selected_device,
        toast_message,
        all_hymos,
        all_compound_water_meters,
    } from "../stores.js";
    import { BASE_API_URL } from "../config.js";
    import ConfirmModal from "../components/modals/ConfirmModal.svelte";
    import { user_permissions, logout, user_role } from "../scripts/auth.js";

    let confirm_title =
        "Sind Sie sicher, dass Sie diesen Alarm quittieren möchten?";
    let confirm_open = false;
    let hidden = false;
    let user_has_quit_alarm_permission =
        $user_role["quit_alarm"] && $user_role["quit_alarm"] == 1
            ? true
            : false;

    const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
    };

    function formatDate(dateString) {
        let date = new Date(dateString);
        return date.toLocaleDateString(undefined, options);
    }

    async function quit_alarm_triggered(alarm_triggered, alarm) {
        let url_extension = `/alarm_triggered/${alarm_triggered.id}/`;
        let request_url = BASE_API_URL + url_extension;
        try {
            const response = await fetch(request_url, {
                method: "PATCH",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(alarm_triggered),
            });
            if (response.status === 200) {
                let response2 = await response.json();
                // Find the index of the alarm_triggered in the alarms_triggered array
                const index = $alarm_list.findIndex(
                    (at) => at.id === alarm_triggered.id,
                );

                // Remove the alarm_triggered from the alarms_triggered array
                $alarm_list.splice(index, 1);
                hidden = true;
                toast_message.set("Alarm quittiert");
            } else {
            }
            return true;
        } catch (error) {
            return false;
        }
    }

    // selecting hymo
    function select_related_device() {
        let device_config = $all_hymos.find(
            (device_config) =>
                device_config.id === alarm_triggered.device_config.id,
        );
        if (device_config && $selected_device !== device_config) {
            $selected_device = device_config;
        } else {
        }
    }

    // selecting water meter
    function select_related_water_meter() {
        let device_config;

        if (alarm_triggered.compound_water_meter) {
            device_config = $all_compound_water_meters.find(
                (device_config) =>
                    device_config.id ===
                    alarm_triggered.compound_water_meter.id,
            );
        } else {
            device_config = $all_compound_water_meters.find((device_config) =>
                device_config.watermeterconfigs.some(
                    (watermeterconfig) =>
                        watermeterconfig.id ===
                        alarm_triggered.device_config.id,
                ),
            );
        }
        if (device_config && $selected_device !== device_config) {
            $selected_device = device_config;
        } else {
        }
    }
</script>

{#if !hidden}
    {#if !show_old_alarms}
        <button
            on:click={() => {
                if (type === "hymo") {
                    select_related_device();
                } else {
                    select_related_water_meter();
                }
            }}
            class="btn btn-normal btn-primary btn-block"
            style="background-color:var(--side-menu-color);"
            ><div class="row bold">
                <div class="col-7 text-left">
                    {alarm_triggered.device_config
                        ? alarm_triggered.channel.measurand
                        : "Volumenstrom"}
                </div>
                <div class="col-5 text-right" style="white-space:wrap;">
                    {formatDate(alarm_triggered.time)}
                </div>
            </div>
            <div class="row mt-1 bold">
                <div class="col-10 gray text-left">
                    {alarm_triggered.device_config
                        ? alarm_triggered.device_config.name
                        : alarm_triggered.compound_water_meter.name}
                </div>

                {#if alarm_triggered.alarm.autoquit == 0 && user_has_quit_alarm_permission}
                    <div id="quit_field" class="col-2 text-right">
                        <button
                            id="quit_button"
                            value="alert_id"
                            class="btn bg-transparent btn-clear white"
                            on:click={(e) => {
                                e.stopPropagation();
                                confirm_open = true;
                            }}
                        >
                            <i class="fa fa-bell-slash"></i>
                        </button>
                    </div>
                {/if}
            </div></button
        >
    {:else}
        <button
            on:click={() => {
                if (type === "hymo") {
                    select_related_device();
                } else {
                    select_related_water_meter();
                }
            }}
            class="btn btn-normal btn-transparent btn-block"
            ><div class="row bold">
                <div class="col-7 text-left">
                    {alarm_triggered.device_config
                        ? alarm_triggered.channel.measurand
                        : "Volumenstrom"}
                </div>
                <div class="col-5 text-right" style="white-space:wrap;">
                    {formatDate(alarm_triggered.time)}
                </div>
            </div>
            <div class="row mt-1 bold">
                <div class="col-10 gray text-left">
                    {alarm_triggered.device_config
                        ? alarm_triggered.device_config.name
                        : alarm_triggered.compound_water_meter.name}
                </div>
            </div></button
        >
    {/if}
{/if}
<ConfirmModal
    bind:show_modal={confirm_open}
    title={confirm_title}
    on:confirm={() => quit_alarm_triggered(alarm_triggered)}
/>
